import React, { useEffect } from "react";
import ChatForm from "./ChatForm";
import ChatMessages from "./ChatMessages";
import { useLocation } from "react-router-dom";
import { decrypt } from "../../utils/crypto";
import { useDispatch } from "react-redux";
import { loaderActions } from "../../redux/slices/loadingSlice";
import { bookingActions } from "../../redux/slices/bookingSlice";
import { useAppSelector } from "../../redux/store";
import getNotices from "../../services/getNotices";
import { noticeActions } from "../../redux/slices/notices";
import BackToHomeBtn from "../../components/BackToHomeBtn";

const ChatPage = () => {
  const booking = useAppSelector((state) => state.booking);

  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      dispatch(loaderActions.showLoader());
      // Perform login action (e.g., API call)
      const reqBody = {
        bookingNumber: booking.bookingNumber,
        name: booking.bookingUsername,
      };

      const response = await getNotices(reqBody);

      if (response === null) {
        dispatch(loaderActions.hideLoader());
        return;
      }

      // Store the booking in redux.
      dispatch(
        noticeActions.setNotices({
          ...response,
        })
      );
      dispatch(loaderActions.hideLoader());
    };

    fetchData();
  }, []);

  return (
    <div className="px-10 py-2">
      <BackToHomeBtn />
      <div className="flex flex-col lg:flex-row gap-10 mt-2">
        {" "}
        <div className="lg:w-1/2">
          <ChatForm />
        </div>
        <div className="lg:w-1/2">
          <ChatMessages />
        </div>
      </div>
    </div>
  );
};

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default ChatPage;
